import apiRequest from './apiRequest';

type Response = {
  fileExtension: string;
  jobID: string;
  referenceImageUploadURL: string;
};

export default async function postCharacterReferenceUploadLink(
  characterName: string,
  fileExtension: string,
) {
  return await apiRequest<Response>(
    'mogen-orchestration',
    `/characters/referenceImageUploadLink`,
    {
      method: 'POST',
      body: JSON.stringify({
        characterName,
        fileExtension,
      }),
    },
  );
}
